module.exports = __webpack_public_path__ + "img/hyman-logo.9ad30c2f.gif";